import { isObject } from 'underscore';

const clearHighlightedSelection = () => {
  if (window.getSelection) {
    window.getSelection()?.removeAllRanges();
  } else if ('selection' in document && isObject(document.selection)) {
    document?.selection?.empty();
  }
};

export default clearHighlightedSelection;
